module.exports = __webpack_public_path__ + "static/Ottawa-Painting-2-1024x768-df9801a856d512dc7fc9a88490767f7b.jpg";